define(
    'config',['json!config.json'],
    function(config)
    {
        return config;
    }
);

